module.exports = __webpack_public_path__ + "media/images/map_icons/Football-dca25430e9d18774501e4519ec0211d9.svg";